'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { useEffect } from 'react';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { parseAsBoolean, useQueryStates } from 'nuqs';
import { disablePreviewMode } from '@/app/api/disable-preview/action';
import { env } from '@/env';
export function PreviewModeIndicator(t0) {
  const $ = _c(10);
  const {
    pageId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      cmsPreview: parseAsBoolean
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [t2] = useQueryStates(t1);
  const {
    cmsPreview
  } = t2;
  let t3;
  let t4;
  if ($[1] !== cmsPreview) {
    t3 = () => {
      if (cmsPreview) {
        fetch(new URL("/api/disable-preview?redirect=false", env.NEXT_PUBLIC_SITE_BASE_URL)).then(_temp).catch(_temp2);
      }
    };
    t4 = [cmsPreview];
    $[1] = cmsPreview;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  if (cmsPreview) {
    return null;
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      position: "fixed",
      bottom: 24,
      right: 24,
      zIndex: 1300,
      p: 2,
      display: "flex",
      alignItems: "center",
      gap: 2,
      bgcolor: "background.paper"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Typography variant="body2" color="warning.main">You are viewing <b>draft</b> content.</Typography>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Button variant="contained" color="warning" size="small" onClick={_temp3} sx={{
      ml: 1
    }}>Exit preview mode</Button>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = `/admin/pages/edit/show/${pageId}`;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      ml: 1
    };
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t8) {
    t10 = <Paper elevation={6} sx={t5}>{t6}{t7}<Button variant="contained" color="warning" size="small" href={t8} sx={t9} target="_blank">Edit in cms</Button></Paper>;
    $[8] = t8;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  return t10;
}
function _temp3() {
  return disablePreviewMode();
}
function _temp2() {}
function _temp() {}